<script lang="ts">
    import { formatPrice } from "../../../../../api/hooks/config-client"

    export let price: BKDFMoney
    export let discount: boolean
    export let oldPrice: boolean
    export let smallVersion = false
</script>

<span
    class:discount="{discount}"
    class:oldprice="{oldPrice}"
    class:smallVersion="{smallVersion}"
>
    <img
        src="../../../../media/bottomRightCrinkle{oldPrice ? 'Blue' : 'Red'}{smallVersion ? 'XS' : ''}.svg"
        id="lefternCrinkle"
        alt="crinkle"
    />
    <em>
        {formatPrice(Number(price.amount))}
    </em>
    <img
        id="righternCrinkle"
        src="../../../../media/topLeftCrinkle{oldPrice ? 'Blue' : 'Red'}{smallVersion ? 'XS' : ''}.svg"
        alt="crinkle"
    />
</span>

<style lang="less">
    span {
        background: var(--primary-100);
        padding: 6px 12px;
        display: flex;
        flex-direction: row;
        height: fit-content;
        gap: 0.5rem;
        position: relative;
        &.oldprice {
            background-color: var(--text-invers-100);
            em {
                color: var(--text-invers-150);
                text-decoration: line-through;
            }
        }
        img {
            position: absolute;
            top: 0px;
        }
        #righternCrinkle {
            right: -6px;
        }
        em {
            color: var(--neutral-white);
            font-weight: 400;
            font-size: 1rem;
            line-height: 0.7rem;
            font-family: "Outfit", sans-serif;
            font-style: normal;
        }
        #lefternCrinkle {
            left: -6px;
        }
        &.smallVersion {
            em {
                font-size: 0.7rem;
                line-height: 0.45rem;
            }
        }
    }
</style>
